import React, { useState, useEffect } from "react";
import { Typography, Table, Button, Image, Tooltip, Dropdown, Menu, message, Avatar, Modal } from "antd";
import { MoreOutlined, UserOutlined } from "@ant-design/icons";
import Pageloader from "../../../components/loader";
import { dataKey, userhasPermissionHelper } from "../../../utils/Helpers";
import PickerPackerFilters from "./filters";
import { useNavigate } from "react-router-dom";
import ModalBtn from "../../../components/modal/universialModal/modalButton";
import ModalBody from "../../../components/modal/universialModal/modalBody";
import Edit from "./menuFormBody/edit";
import Block from "./menuFormBody/block";

import * as actionPage from "../../../redux/actions/pickerPakerPage.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PERMISSION_CONSTANT } from "../../../utils/constants/app";
import EditPasscode from "./menuFormBody/editPasscode";

const { Title, Text } = Typography;
const pageName = "Picker Packer";
const pageLink = "pickerpacker";

const PickerPackerListing = (props) => {
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [modalOpen, setModalOpen] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(props.pageFilter) {
      postLists(props.pageFilter)
    }
  }, [props.pageFilter]);

  useEffect(() => {
    setPostData(dataKey(props.pageData));
  }, [props.pageData]);

  const postLists = async (data) => {
    // const [start, end] = (data?.date === null || data?.date === undefined) ? "" : data?.date;
    const newData = {
      ...data,
      // startDate: start === undefined ? moment() : start.toISOString(),
      // endDate: end === undefined ? moment() : end.toISOString(),
    };
    const { searchOption, ...rest } = newData;
    try {
      if (rest) {await props.actionPage.listAction(rest)}
    } catch (e) {}
  };

  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.pageFilter,
      page: page,
      limit: limit,
    };
    await props.actionPage.filterAction(pageData);
  };

  const characterLength = (value) => {
    return value.length > 10 ? `${value.substring(0, 10)}...` : value;
  };

  // Modal Start **********************
  const modalCancel = () => {
    setModalOpen(null)
  }

  const modalonAction = (value=null, type=null, formBody=null) => {
    setModalOpen(()=>({
      modal: true,
      value: value,
      type: type,
      formBody: formBody,
    }))
  }

  const handleSuspended = async (pickerPackerId, riderStatus) => {
    console.log(pickerPackerId, riderStatus);
    const data = {
      "pickerPackerId": pickerPackerId,
      "status": riderStatus
    }
    try {
      setLoading(true);
      if (data)
        await props.actionPage.suspendedAction(data);
    } catch (e) {} finally {
      setLoading(false);
      postLists(props.pageFilter)
    }
  }
  
  const onCreateAction = async (values, info) => {
    console.log('values, info', values, info)

    if (info?.type === 'edit passcode') {
      const newData = {
        ...values,
      }
      try {
        await props.actionPage.patchPasscodeAction(info?.value?.id, newData).then((res)=>{
          {message.success(res.data.message)}
        });
        postLists(props.pageFilter)
        modalCancel()
      } catch {}
    }

    if (info?.type === 'edit') {
      const newData = {
        ...values,
      }
      try {
        await props.actionPage.patchAction(info?.value?.id, newData).then((res)=>{
          {message.success(res.data.message)}
        });
        postLists(props.pageFilter)
        modalCancel()
      } catch {}
    }

    if (info?.type === 'Block' || info?.type === 'Unblock') {
      try {
        await props.actionPage.blockAction(info?.value).then((res)=>{
          {message.success(res.data.message)}
        });
        modalCancel()
        postLists(props.pageFilter)
      } catch {}
    }
    if (info?.type === 'Suspended' || info?.type === 'Available') {
      try {
        await props.actionPage.suspendedAction(info?.value).then((res)=>{
          {message.success(res.data.message)}
        });
        modalCancel()
        postLists(props.pageFilter)
      } catch {}
    }
    if (info?.type === 'approve'){
      try {
        await props.actionPage.approveAction(info?.value).then((res)=>{
          {message.success(res.data.message)}
        });
        modalCancel()
        postLists(props.pageFilter)
      } catch {}
    }
  }
  // Modal End **********************



  const columns = [
    {
      title: "P/P ID",
      dataIndex: "display_id",
      render: (value) => (value || '-'),
    },
    {
      title: "Image",
      dataIndex: "profileImage",
      render: (value) => (value ? <Image alt="Profile Image" src={value} /> : <Avatar shape="square" size={30} icon={<UserOutlined/>}/> )
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      render: (value) => value ? (<Tooltip title={value}><Text>{characterLength(value)}</Text></Tooltip>):("-"),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (value) =>value ? (<Tooltip title={value}><Text>{characterLength(value)}</Text></Tooltip>):("-"),
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      render: (value) => (value || '-'),
    },
    {
      title: "Device Type",
      dataIndex: "deviceType",
      render: (value) => (value || '-'),
    },
    {
      title: "Device Version",
      dataIndex: "deviceId",
      render: (value) => value ? <Text>{characterLength(value)}</Text> : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (value) => (value ? <Text type={[
        value === "available" ? "success" :
        value === "approved" ? "secondary" :
        value === "pending" ? "warning" :
        value === "blocked" ? "danger" :
        value === "suspended" ? "danger" :
        value === "inactive" ? "danger" :
        ''
      ]}>{value}</Text> : '-')
    },
    {
      title: "CNIC",
      dataIndex: "cnic",
      render: (value) => (value || '-'),
    },
    {
      title: "Action",
      render: (value) => (
        <Dropdown overlay={() =>actions(value, value.id, value.status)}>
          <a onClick={(e) => e.preventDefault()}><Button disabled={props?.pageLoading}><MoreOutlined /></Button></a>
        </Dropdown>
      )
    },
  ];

  const actions = (value, pickerPackerId, riderStatus) => {
    const item = [];
    if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_PICKER_PACKER)){
      item.push(
        {
          key: "1",
          label: <ModalBtn onAction={modalonAction} formBody={Edit} value={value} title="edit" />
        },{
          key: "2",
          label: <ModalBtn onAction={modalonAction} formBody={EditPasscode} value={value} title="edit passcode" />
        }
        // ,{
        //   key: "3",
        //   label: <ModalBtn onAction={modalonAction} formBody={EditPasscode} value={value} title="edit passcode" />
        // }
      );
    }
      
    item.push(...[
      (
        ( riderStatus !== "blocked" && (riderStatus==="suspended" || riderStatus==='inactive') ) ? {
        key: "7",
        label: (<div style={{pointerEvents: (riderStatus === "available" || riderStatus === "approved") ? "none" : "auto", }}>
          <a onClick={() => Modal.confirm({
            content: (riderStatus === "suspended" || riderStatus === "inactive") ? "Are you sure you want to Activate Rider": "",
            centered: true,
            maskClosable: true,
            onOk: async () => await handleSuspended(pickerPackerId, (riderStatus==="suspended" || riderStatus==="inactive") ?"available":""),
          })} >
            {riderStatus==="suspended" || riderStatus==='inactive'?"Active":""}
          </a>
        </div>)}: ""
      ),
      (
        ( riderStatus !== "blocked" && (riderStatus === "available" || riderStatus === "approved")) ? {
        key: "8",
        label: (<div style={{pointerEvents: (riderStatus === "available" || riderStatus === "approved") ? "auto" : "none", }}>
          <a onClick={() => Modal.confirm({
            content: (riderStatus === "available" || riderStatus === "approved") ? "Are you sure you want to Inactive Rider":"",
            centered: true,
            maskClosable: true,
            onOk: async () => await handleSuspended(pickerPackerId, (riderStatus === "available" || riderStatus === "approved") ? "inactive":""),
          })} >
            {(riderStatus === "available" || riderStatus === "approved") ? "Inactive":""}
          </a>
        </div>)}: ""
      ),
      // (
      //   value?.status==='pending'?"":value?.status==='available' || value?.status==='blocked' ?{
      //     key: "4",
      //     label: <ModalBtn onAction={modalonAction} formBody={<Block value={{fullName:value?.fullName,status:value?.status==='blocked'?'Unblock':'Block' }}/>} value={{pickerPackerId:value?.id,status:value?.status==='blocked'?'available':'blocked' }} title={value?.status==='blocked'?'Unblock':'Block'} />
      //   }:""
      // ),
      // (
      //   value?.status==='pending'?"": value?.status==='available' || value?.status==='suspended' ?{
      //     key: "5",
      //     label: <ModalBtn onAction={modalonAction} formBody={<Block value={{fullName:value?.fullName,status:value?.status==='suspended'?'Available':'Suspended' }}/>} value={{pickerPackerId:value?.id,status:value?.status==='suspended'?'available':'suspended'}} title={value?.status==='suspended'?'Available':'Suspended'} />,
      //   }:""
      // ),
      (
        value?.status==='pending'?{
          key: "6",
          label: <ModalBtn onAction={modalonAction} formBody={<Block value={{fullName:value?.fullName, status:'Approve' }}/>} value={{pickerPackerId:value?.id}} title={'approve'} />,
          // label: <a onClick={() => actionsEdit(value)}>Approve</a>
        }:""
      ),
    ]);
    return <Menu items={item}/>
  };

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{`${pageName}`}</Title>
        { userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.CREATE_PICKER_PACKER) &&
          <div className="pch">
            <Button onClick={() => navigate(`/${pageLink}/add`)}>{`${pageName} Add`}</Button>
          </div>
        } 
      </div>
        <PickerPackerFilters />
      <div className="p-content">
        {props.pageLoading ? <Pageloader /> : <>
          <Table
            dataSource={postData}
            columns={columns}
            pagination={{
              total: props.pagePagination?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: props.pagePagination?.limit,
              defaultCurrent: props.pagePagination?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (currentPage, pageSize) => {
                paginationChange(currentPage, pageSize);
              },
            }}
            onRow={(r) => ({
              onDoubleClick: (e) => window.open(`/${pageLink}/${r.id}`),
            })}
          />
          {modalOpen && <ModalBody modalOpen={modalOpen} Loading={props.pageLoading} modalCancel={modalCancel} onCreateAction={onCreateAction}/>}
        </>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
return {
  pageData: state.PickerPakerPageReducer?.initialData,
  pagePagination: state.PickerPakerPageReducer?.initialPagination,
  pageLoading: state.PickerPakerPageReducer?.initialLoading,
  pageFilter: state.PickerPakerPageReducer?.initialFilter,
  permissions: state.PermissionReducer.permissions,
};
};
const mapDispatchToProps = (dispatch) => {
return {
  actionPage: bindActionCreators(actionPage, dispatch),
};
};

export default connect(mapStateToProps, mapDispatchToProps)(PickerPackerListing);
